/* esm.sh - rxjs@7.8.2/dist/esm/internal/scheduler/async */
import{AsyncAction as c}from"rxjs/dist/esm/internal/scheduler/AsyncAction";import{AsyncScheduler as o}from"rxjs/dist/esm/internal/scheduler/AsyncScheduler";var n=new o(c),t=n;export{t as async,n as asyncScheduler};
//# sourceMappingURL=async.mjs.map